/** Impressão do roteiro (mesmo layout do TodayRouteModal). */

import { getBoardClienteExibicao } from '../../board/utils/clienteBoardDisplay';
import {
  ROUTE_PRINT_DEFEITO_CSS,
  buildRouteDefeitoPrintRows,
  escapeRoutePrintHtml,
} from '../../board/utils/routePrintReportUtils';

function formatDateLocal(d) {
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

function formatDateTimeLocal(d = new Date()) {
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

function formatPrevisaoPrint(dateTimeString) {
  if (!dateTimeString) return 'N/A';
  try {
    const date = new Date(dateTimeString);
    if (Number.isNaN(date.getTime())) return 'N/A';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch {
    return 'N/A';
  }
}

function orderNumberLabel(ordem) {
  const n = Number(ordem?.TB02115_ORDEM);
  if (!Number.isFinite(n) || n <= 0) return '-';
  return String(n);
}

function getEquipment(ordem) {
  return ordem.TB01010_RESUMIDO || ordem.TB01010_NOME || 'N/A';
}

/**
 * Abre janela de impressão do roteiro do técnico (dados today-route).
 * @param {{ technicianName: string, orders: object[] }} params
 */
export function printTechnicianOpenRoute({ technicianName, orders }) {
  const sortedData = [...(orders || [])].sort((a, b) => {
    const orderA = Number(a.TB02115_ORDEM) || 0;
    const orderB = Number(b.TB02115_ORDEM) || 0;
    return orderA - orderB;
  });

  const today = new Date();
  const reportDate = formatDateLocal(today);
  const reportDateTime = formatDateTimeLocal(today);
  const tech = escapeRoutePrintHtml(technicianName || '—');

  const rowsHtml = sortedData
    .map((ordem) => {
      const cliente =
        getBoardClienteExibicao(ordem) ||
        ordem.TB01008_NOME ||
        'N/A';
      return `
        <tr>
          <td>${escapeRoutePrintHtml(orderNumberLabel(ordem))}</td>
          <td>${escapeRoutePrintHtml(ordem.TB02115_CODIGO || 'N/A')}</td>
          <td>${escapeRoutePrintHtml(ordem.PEDIDO_VINCULADO || ordem.pedidoVinculado || 'N/A')}</td>
          <td>${escapeRoutePrintHtml(cliente)}</td>
          <td>${escapeRoutePrintHtml(getEquipment(ordem))}</td>
          <td>${escapeRoutePrintHtml(ordem.TB02115_NUMSERIE || 'N/A')}</td>
          <td>${escapeRoutePrintHtml(ordem.TB02112_PAT || 'N/A')}</td>
          <td>${escapeRoutePrintHtml(ordem.TB02115_CIDADE || 'N/A')}</td>
          <td>${escapeRoutePrintHtml(ordem.TB02115_BAIRRO || 'N/A')}</td>
          <td>${escapeRoutePrintHtml(formatPrevisaoPrint(ordem.CALC_PREVISAO))}</td>
        </tr>
        ${buildRouteDefeitoPrintRows(ordem)}
      `;
    })
    .join('');

  const printContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Roteiro de Atendimento Técnico</title>
  <style>
    @page { size: A4 landscape; margin: 1.5cm; }
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body {
      font-family: 'Geist Variable', 'Geist', system-ui, sans-serif;
      font-size: 10px;
      color: #2d3748;
      line-height: 1.3;
    }
    .report-header { text-align: left; margin-bottom: 10px; }
    .report-header h1 {
      font-size: 16px;
      font-weight: 600;
      color: #2d3748;
      margin-bottom: 8px;
    }
    .report-technician {
      text-align: left;
      font-size: 13px;
      font-weight: 500;
      color: #4a5568;
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 2px solid #7c4dff;
    }
    .report-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 15px;
      table-layout: fixed;
    }
    .report-table thead {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-bottom: 2px solid #e2e8f0;
    }
    .report-table th {
      padding: 8px 6px;
      text-align: left;
      font-weight: 600;
      color: #2d3748;
      font-size: 9px;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      border-bottom: 2px solid #e2e8f0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .report-table td {
      padding: 6px;
      border-bottom: 1px solid #f1f5f9;
      font-size: 9px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .report-total {
      margin-top: 12px;
      padding-top: 8px;
      border-top: 2px solid #e2e8f0;
      font-weight: 600;
      font-size: 10px;
      color: #2d3748;
    }
    .report-footer {
      margin-top: 20px;
      padding-top: 8px;
      border-top: 1px solid #e2e8f0;
      text-align: right;
      font-size: 8px;
      color: #64748b;
    }
    .col-number { width: 4%; }
    .col-os { width: 5%; }
    .col-pedido { width: 5%; }
    .col-cliente { width: 17%; }
    .col-equipamento { width: 23%; }
    .col-serie { width: 7%; }
    .col-patrimonio { width: 7%; }
    .col-cidade { width: 11%; }
    .col-bairro { width: 11%; }
    .col-previsao { width: 10%; }
    ${ROUTE_PRINT_DEFEITO_CSS}
  </style>
</head>
<body>
  <div class="report-header">
    <h1>Roteiro de atendimento técnico - ${reportDate}</h1>
    <div class="report-technician">${tech}</div>
  </div>
  <table class="report-table">
    <thead>
      <tr>
        <th class="col-number">#</th>
        <th class="col-os">OS</th>
        <th class="col-pedido">PEDIDO</th>
        <th class="col-cliente">Cliente</th>
        <th class="col-equipamento">Equipamento</th>
        <th class="col-serie">Série</th>
        <th class="col-patrimonio">Patrimônio</th>
        <th class="col-cidade">Cidade</th>
        <th class="col-bairro">Bairro</th>
        <th class="col-previsao">Previsão</th>
      </tr>
    </thead>
    <tbody>
      ${rowsHtml || `<tr><td colspan="10">Nenhuma ordem encontrada</td></tr>`}
    </tbody>
  </table>
  <div class="report-total">Total de ordens de serviço: ${sortedData.length}</div>
  <div class="report-footer">Relatório emitido em ${reportDateTime}</div>
</body>
</html>`;

  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    window.alert('Não foi possível abrir a janela de impressão. Verifique o bloqueador de pop-ups.');
    return;
  }
  printWindow.document.write(printContent);
  printWindow.document.close();
  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.print();
    }, 250);
  };
}
